// extracted by mini-css-extract-plugin
export default {"container":"ReferralMobileChat_container__3+0rB","frame":"ReferralMobileChat_frame__FiCLL"};